// Click-to-load YouTube facade for the workshop video section (spec §6.2, §12): the poster and play button render as a
// plain link to YouTube, and the iframe is only injected when the visitor asks for it, so nothing third-party loads
// with the page.
if (!window.customElements.get('workshop-video-facade')) {
  window.customElements.define('workshop-video-facade', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-youtube-id]');
      this.trigger?.addEventListener('click', (event) => this.load(event), { once: true });
    }

    load(event) {
      event.preventDefault();

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.trigger.dataset.youtubeId)}?autoplay=1&rel=0&playsinline=1`;
      iframe.title = this.trigger.dataset.title || '';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.className = 'workshop-video__iframe';

      this.trigger.replaceWith(iframe);
      iframe.focus();
    }
  });
}
